import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PickAndMixCard from 'Components/PickAndMix/Cards/PickAndMixCard';
import useViewport from 'Hooks/useViewport';

function PickAndMixHits({
  hits,
  switchCarouselGame,
}) {
  const { isLg } = useViewport();


  return (
    <section className="fan-grid-container PickAndMixHits">
      {hits.map((hit, i) =>
        <div className={classNames({ 'two-column-row': isLg }, { 'three-column-row': !isLg })} key={hit._id}>
          <PickAndMixCard
            cardIndex={i}
            lazy={i > 9}
            key={hit._id}
            hit={hit}
            switchCarouselGame={switchCarouselGame}
          />
        </div>,
      )}
    </section>
  );
}

PickAndMixHits.propTypes = {
  switchCarouselGame: PropTypes.func,
  hits: PropTypes.arrayOf(PropTypes.shape({})),
};

PickAndMixHits.defaultProps = {
  hits: [],
  switchCarouselGame: () => {},
  slug: '',
};

export default PickAndMixHits;
